export const BOUNDARY_RENDERING_START = 'BOUNDARY_RENDERING_START';
export const BOUNDARY_RENDERING_STOP = 'BOUNDARY_RENDERING_STOP';

export const BOUNDARY_SELECT_RENDERING_START = 'BOUNDARY_SELECT_RENDERING_START';
export const BOUNDARY_SELECT_RENDERING_STOP = 'BOUNDARY_SELECT_RENDERING_STOP';

export const BOUNDARY_RENDERING_EXPECTED_RESET = 'BOUNDARY_RENDERING_EXPECTED_RESET';
